import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSync } from '@fortawesome/pro-light-svg-icons'

import { SidebarModal, SquareIconWithBackground } from '@domain-group/suit-theme'

import useCampaign from '@hooks/useCampaign'

interface ImportCampaignButtonProps {
  agencyId: number,
}

const ImportCampaignButton = (props: ImportCampaignButtonProps) => {
  const { agencyId } = props

  const campaignPayload = useCampaign({ agency_id: agencyId })
  const { callbacks: { importCampaign } } = campaignPayload

  return (
    <SidebarModal.Button
      iconLeft={
        <SquareIconWithBackground backgroundColor="#F8F7F4" color="tan" icon={<FontAwesomeIcon icon={faSync} />} />
      }
      onClick={() => importCampaign()}
      showAngleIcon
      subtitle="Import from external CRM"
      title="Import from CRM"
    />
  )
}
export default ImportCampaignButton
